
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M8.89998 6C8.89998 4.29 10.29 2.9 12 2.9C13.71 2.9 15.1 4.29 15.1 6V8H10.44L20 17.56V10C20 8.9 19.1 8 18 8H17V6C17 3.24 14.76 1 12 1C9.67998 1 7.73998 2.59 7.17998 4.74L8.89998 6.46V6ZM5.11998 5.51C4.72998 5.12 4.09998 5.12 3.70998 5.51C3.31998 5.9 3.31998 6.53 3.70998 6.92L5.03998 8.25C4.41998 8.6 3.99998 9.25 3.99998 10V20C3.99998 21.1 4.89998 22 5.99998 22H18.78L19.07 22.29C19.46 22.68 20.09 22.68 20.48 22.29C20.87 21.9 20.87 21.27 20.48 20.88L5.11998 5.51Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-no-encryption-gmailerrorred`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconNoEncryptionGmailerrorred

    ```js
    <b-new-b-icon-no-encryption-gmailerrorred />
    ```
</docs>


